import { Injectable, inject } from '@angular/core';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { StateMemento, WINDOW } from 'wflow-cdk';
import { AuthService } from '../../auth/auth.service';

/**
 * Get user session ID and save to session storage for send to BE
 */
@Injectable({
  providedIn: 'root',
})
export class UserSessionIdService {
  readonly #EXPIRED_TIME = 10 * 60 * 1000;

  readonly #storage: StateMemento<{
    created: number;
    user: string;
    id: string;
  }>;
  readonly #authSvc = inject(AuthService);

  get sessionId() {
    return this.#storage.state?.id;
  }

  constructor() {
    this.#storage = new StateMemento({
      storage: inject(WINDOW)?.sessionStorage,
      key: 'USER_SESSION_GUID',
    });

    this.#authSvc.userData$
      .pipe(
        distinctUntilChanged((x, y) => x?.email === y?.email),
        filter((v) => !!v),
      )
      .subscribe((session) => {
        if (
          this.#storage.state &&
          this.#storage.state.user === session.email &&
          this.#isExpired(this.#storage.state.created)
        ) {
          return;
        }

        this.#storage.change({
          created: Date.now(),
          user: session.email,
          id: session.sub,
        });
      });
  }

  #isExpired(timestamp: number): boolean {
    return Date.now() - timestamp <= this.#EXPIRED_TIME;
  }
}
